// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DisplayTooltipsContainer__tooltipFrame___wr6Kz {
	padding: 7px 13px !important;
	border: 1px solid #8f6b37 !important;
	border-radius: 4px !important;
	background: #080908 !important;
	box-shadow:
		0 0 2px rgba(143, 107, 55, 0.45),
		0 4px 6px rgba(0, 0, 0, 0.42);
}

.DisplayTooltipsContainer__tooltipFrame___wr6Kz::before,
.DisplayTooltipsContainer__tooltipFrame___wr6Kz::after {
	display: none !important;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltipFrame": `DisplayTooltipsContainer__tooltipFrame___wr6Kz`
};
module.exports = ___CSS_LOADER_EXPORT___;
